module.exports = __webpack_public_path__ + "Roboto-Regular-webfont.3e5675c89f974f7811ee.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/gfurtado/Projects/v2.3 (ng4 2.1 only)/Angular 4 CLI/app/src/assets/fonts/roboto/Roboto-Regular-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Regular-webfont.woff
// module chunks = styles